import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '../../../app/api/apiSlice'

const userImprintHiddenMagicsAdapter = createEntityAdapter({})

const initialState = userImprintHiddenMagicsAdapter.getInitialState()

export const userImprintHiddenMagicsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserImprintHiddenMagics: builder.query({
            query: () => ({
                url: '/userImprintHiddenMagics/getUserImprintHiddenMagics',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedUserImprintHiddenMagics = responseData.map(userImprintHiddenMagic => {
                    userImprintHiddenMagic.id = userImprintHiddenMagic._id
                    return userImprintHiddenMagic
                })
                return userImprintHiddenMagicsAdapter.setAll(initialState, loadedUserImprintHiddenMagics)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'UserImprintHiddenMagic', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'UserImprintHiddenMagic', id}))
                    ]
                } else {
                    return [ { type: 'UserImprintHiddenMagic', id: 'LIST'}]
                }
            },
        }),
        createNewUserImprintHiddenMagic: builder.mutation({
            query: initialUserImprintHiddenMagic => ({
                url: '/userImprintHiddenMagics/createNewUserImprintHiddenMagic',
                method: 'POST',
                body: {...initialUserImprintHiddenMagic,}
            }),
            invalidatesTags: [
                { type: 'UserImprintHiddenMagic', id: "LIST" }
            ] 
        }),
        updateUserImprintHiddenMagic: builder.mutation({
            query: initialUserImprintHiddenMagic => ({
                url: '/userImprintHiddenMagics/updateUserImprintHiddenMagic',
                method: 'PATCH',
                body: {...initialUserImprintHiddenMagic,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'UserImprintHiddenMagic', id: arg.id },
                { type: 'UserImprintHiddenMagic', id: 'LIST' }
            ],
        }),
        deleteUserImprintHiddenMagic: builder.mutation({
            query: ({id}) => ({
                url: '/userImprintHiddenMagics/deleteUserImprintHiddenMagic',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserImprintHiddenMagic', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetUserImprintHiddenMagicsQuery,
    useCreateNewUserImprintHiddenMagicMutation,
    useUpdateUserImprintHiddenMagicMutation,
    useDeleteUserImprintHiddenMagicMutation,
} = userImprintHiddenMagicsApiSlice

// returns the query result object
export const selectUserImprintHiddenMagicResult = userImprintHiddenMagicsApiSlice.endpoints.getUserImprintHiddenMagics.select()

// create memoized selector
const selectUserImprintHiddenMagicsData = createSelector(
    selectUserImprintHiddenMagicResult,
    userImprintHiddenMagicResult => userImprintHiddenMagicResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserImprintHiddenMagics,
    selectById: selectUserImprintHiddenMagicById,
    selectIds: selectUserImprintHiddenMagicIds,
} = userImprintHiddenMagicsAdapter.getSelectors(state => selectUserImprintHiddenMagicsData(state) ?? initialState)